var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1800 1799.999925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 251.101562 180 L 1548 180 L 1548 1620 L 251.101562 1620 Z M 251.101562 180 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.468506%,25.099182%,21.569824%)",
      fillOpacity: 1
    },
    d: "M 1547.410156 658.800781 C 1547.410156 1396.800781 899.703125 1620 899.703125 1620 C 899.703125 1620 251.996094 1396.800781 251.996094 658.800781 C 251.996094 568.800781 259.191406 493.199219 266.390625 432 C 277.183594 342 338.355469 270 424.71875 248.398438 C 536.269531 216 712.589844 180 899.703125 180 C 1086.820312 180 1263.140625 216 1378.289062 248.398438 C 1464.648438 270 1525.820312 345.601562 1536.617188 432 C 1540.214844 493.199219 1547.410156 572.398438 1547.410156 658.800781 Z M 1547.410156 658.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.798889%,68.629456%,31.369019%)",
      fillOpacity: 1
    },
    d: "M 899.703125 288 C 1076.023438 288 1241.550781 324 1349.5 352.800781 C 1392.679688 363.601562 1421.46875 399.601562 1428.664062 446.398438 C 1435.863281 514.800781 1439.460938 586.800781 1439.460938 658.800781 C 1439.460938 1220.398438 1025.648438 1447.199219 899.703125 1501.199219 C 773.761719 1443.601562 359.949219 1216.800781 359.949219 658.800781 C 359.949219 586.800781 363.546875 514.800781 370.742188 446.398438 C 374.339844 399.601562 406.726562 363.601562 449.90625 352.800781 C 557.859375 324 723.382812 288 899.703125 288 M 899.703125 180 C 712.589844 180 536.269531 216 421.121094 248.398438 C 338.355469 270 273.585938 345.601562 266.390625 432 C 259.191406 493.199219 251.996094 572.398438 251.996094 658.800781 C 251.996094 1396.800781 899.703125 1620 899.703125 1620 C 899.703125 1620 1547.410156 1396.800781 1547.410156 658.800781 C 1547.410156 568.800781 1540.214844 493.199219 1533.015625 432 C 1522.222656 342 1461.050781 270 1374.6875 248.398438 C 1263.140625 216 1086.820312 180 899.703125 180 Z M 899.703125 180 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.268616%,92.939758%,78.42865%)",
      fillOpacity: 1
    },
    d: "M 863.71875 1044 L 935.6875 1044 L 935.6875 1332 L 863.71875 1332 Z M 863.71875 1044 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.798889%,68.629456%,31.369019%)",
      fillOpacity: 1
    },
    d: "M 899.703125 396 C 899.703125 396 683.800781 576 683.800781 864 C 683.800781 1051.199219 802.546875 1170 863.71875 1224 L 899.703125 1116 L 935.6875 1224 C 996.859375 1170 1115.605469 1051.199219 1115.605469 864 C 1115.605469 576 899.703125 396 899.703125 396 Z M 899.703125 396 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.588989%,78.039551%,51.759338%)",
      fillOpacity: 1
    },
    d: "M 899.703125 396 C 899.703125 396 683.800781 576 683.800781 864 C 683.800781 1051.199219 802.546875 1170 863.71875 1224 L 899.703125 1116 Z M 899.703125 396 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoLogo);
export default __webpack_public_path__ + "static/media/MongoLogo.f10581eb8338686fb7c1a0cc0d9c8032.svg";
export { ForwardRef as ReactComponent };